/**
 * Saudi riyal.
 */
export var SAR = {
  code: 'SAR',
  base: 10,
  exponent: 2
};